import axios from "axios";
import { toast } from "react-toastify";
import { logout } from "./auth-scripts";
import { t } from "i18next";
import { BASE_URL } from "../config";

// export const backendUrl = "http://localhost:6671";
export const backendUrl = BASE_URL;

const api = axios.create({
  baseURL: backendUrl,
  withCredentials: true,
});

let sessionExpired = false;

export const setupInterceptors = (navigate, setUser) => {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 403) {
        if (!sessionExpired) {
          sessionExpired = true;

          if (
            window.location.pathname !== "/" &&
            !window.location.pathname.startsWith("/forgot-password") &&
            !window.location.pathname.startsWith("/reset-password") &&
            !window.location.pathname.startsWith("/sign-up")
          ) {
            if (!toast.isActive("session-expired")) {
              toast.error(t("toast.index.session_error"), {
                toastId: "session-expired",
              });
            }
            logout(navigate, toast, setUser);
          }
        }

        return Promise.reject({ ...error, suppressToast: true });
      }

      return Promise.reject(error);
    }
  );
};

export default api;
